import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

/**
 * React Query hook for fetching partner leads overview for system admin.
 *
 * Returns aggregated pipeline statistics across all partners including:
 * - Total pipeline value and cashback potential
 * - Status distribution
 * - Top partners by pipeline value
 */
export const useGetPartnerLeadsOverviewQuery = () => {
  const { getPartnerLeadsOverview } = useServicesContext();

  return useQuery({
    queryKey: ['GET_PARTNER_LEADS_OVERVIEW'],
    queryFn: getPartnerLeadsOverview,
  });
};
